import {
  LITHIUM_ION_BATTERIES,
  PA_SUBSCRIPTION_PREFIX,
} from '~/constants/services/constants'
import {
  getAdaptedSummaryTable,
  SUMMARY_PRICE_DAILY_COLUMNS,
} from '~/utils/adapters'

const PRICE_DAILY_INDICATOR_NAME = 'Daily Price Indicator'
const PRICE_DAILY_INDICATOR_PRICE_TYPE_NAME = 'Daily Price Indicator'

const getSummariesWithPriceDailyIndicator = (summaries) => {
  const filteredSummaries = summaries
    .filter((summary) =>
      summary.series.some(
        (serie) =>
          serie.priceType.name === PRICE_DAILY_INDICATOR_PRICE_TYPE_NAME,
      ),
    )
    .map((summary) => {
      const series = summary.series.filter(
        (serie) =>
          serie.priceType.name === PRICE_DAILY_INDICATOR_PRICE_TYPE_NAME,
      )
      return { ...summary, series }
    })
    .map((summary) => ({ ...summary, name: PRICE_DAILY_INDICATOR_NAME }))

  return getAdaptedSummaryTable({
    summaries: filteredSummaries,
    columns: SUMMARY_PRICE_DAILY_COLUMNS,
  }).map((summary) => {
    const values = summary.values.map((value) => ({ ...value, dotted: true }))

    return { ...summary, values }
  })
}

const getSummariesWithoutPriceDailyIndicator = (summaries) => {
  const filteredSummaries = summaries
    .map((summary) => {
      const series = summary.series.filter(
        (serie) =>
          serie.priceType.name !== PRICE_DAILY_INDICATOR_PRICE_TYPE_NAME,
      )
      return { ...summary, series }
    })
    .filter((summary) => summary.series.length > 0)
  return getAdaptedSummaryTable({ summaries: filteredSummaries })
}

export function getAdaptedSummaries(
  summaries: { data: any[]; $metadata: { product: any }; authorized: any }[],
) {
  const allSummaries = summaries
    .map(
      (summary: {
        data: any[]
        $metadata: { product: any }
        authorized: any
      }) => {
        summary.data.forEach((data) => {
          data.subscription = getPASubscription(summary.$metadata.product)
          data.productName = getLibNameByMarket(summary.$metadata.product)
          data.authorized = summary.authorized
        })
        return summary.data
      },
    )
    .flat()

  return {
    summariesDailyPriceIndicator:
      getSummariesWithPriceDailyIndicator(allSummaries),
    summaries: getSummariesWithoutPriceDailyIndicator(allSummaries),
  }
}

// LiB is Lithium ion Batteries
export function getLibNameByMarket(marketName?: string) {
  return ['lithium-ion-batteries', LITHIUM_ION_BATTERIES.name].some(
    (label) => label.toLowerCase() === marketName?.toLowerCase(),
  )
    ? 'Lithium ion Batteries'
    : marketName
}

function getPASubscription(product) {
  let slug = product.toLowerCase().replace(/ /g, '-')
  if (slug === 'lithium-ion-batteries') slug = 'battery-cell'
  return `${PA_SUBSCRIPTION_PREFIX}${slug}`
}
